// extracted by mini-css-extract-plugin
export default {"container":"HW11_container__fXfUR","wrapper":"HW11_wrapper__pvJTG","number":"HW11_number__-QzkV"};